import { getLocalLanguage } from "./language";

// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo for details:
type CompatibleIntlLocale = { getWeekInfo(): { firstDay: number } } | { weekInfo: { firstDay: number } };

function clamp(value: number): 0 | 1 | 2 | 3 | 4 | 5 | 6 {
  if (value < 0) return 0;
  return (Math.floor(value) % 7) as 0 | 1 | 2 | 3 | 4 | 5 | 6;
}

export function weekStartsOn(): 0 | 1 | 2 | 3 | 4 | 5 | 6 {
  // Old browsers (e.g. Safari 13.1) don't have Int.Locale:
  if (typeof Intl.Locale !== "function") {
    return 0;
  }

  const locale = new Intl.Locale(getLocalLanguage()) as unknown as CompatibleIntlLocale;

  if ("getWeekInfo" in locale && typeof locale.getWeekInfo === "function") {
    return clamp(locale.getWeekInfo().firstDay);
  }
  if ("weekInfo" in locale && typeof locale.weekInfo === "object") {
    return clamp(locale.weekInfo.firstDay);
  }

  // default to sunday:
  return 0;
}
